import customFetch from "@/services/fetch";
import {useToast} from "vue-toastification";

const toast = useToast();

export default function useApi() {
    const fetchResource = async function (endpoint, options = {}) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            const defaultOptions = {
                method: 'GET',
                ...options,
            };

            return await customFetch(`/${endpoint}`, defaultOptions)
        } catch (error) {
            toast.error(error.message);
            throw error;
        }
    }

    const createResource = async function (endpoint, data) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');

            return await customFetch(`/${endpoint}`, {
                method: "POST",
                body: JSON.stringify(data),
            });
        } catch (error) {
            toast.error(error.message);
            throw error;
        }
    }

    const updateResource = async function (endpoint, data) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');

            return await customFetch(`/${endpoint}`, {
                method: "PUT",
                body: JSON.stringify(data),
            });
        } catch (error) {
            toast.error(error.message);
            throw error;
        }
    }

    const deleteResource = async function (endpoint) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');

            await customFetch(`/${endpoint}`, {
                method: "DELETE",
            });
        } catch (error) {
            toast.error(error.message);
            throw error;
        }
    }

    const uploadFile = async function (endpoint, formData) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');

            return await customFetch(`/${endpoint}`, {
                method: "POST",
                body: formData,
            }, false);
        } catch (error) {
            toast.error(error.message || 'خطا در آپلود فایل');
            throw error;
        }
    }

    return {
        fetchResource,
        createResource,
        updateResource,
        deleteResource,
        uploadFile,
    }
}
